import type { BannerItem } from "$root/components/banner-stack/types";
import type { FormatDate } from "$root/localization/formatters";
import { ActionText } from "@mdotm/shadcn/legacy/components";
import type { TFunction } from "i18next";
import type { QuantityEditorBuilderProps } from "../builder";
import { unvaluedCount } from "./sizing";

/**
 * Rows a reprice could not value on Cold War, which still show the previous day's market value and
 * weight under the market date's price. They keep the composition from being saved until a retry,
 * a typed edit or another day values them; the banner's action retries them all.
 */
export function unvaluedRowsBanner({
	instrumentBuilder,
	t,
	formatDate,
}: {
	instrumentBuilder: Pick<QuantityEditorBuilderProps, "getComposition" | "getMarketDate" | "retryValuations">;
	t: TFunction;
	formatDate: FormatDate;
}): BannerItem | null {
	const count = unvaluedCount(instrumentBuilder.getComposition({ removeDeleted: true }).values());
	if (count === 0) {
		return null;
	}
	return {
		id: "unvalued-rows",
		severity: "warning",
		title: t("EDIT_COMPOSITION.POSITION_SIZING.VALUATION_FAILED_NOTICE.TITLE"),
		description: (
			<span data-qualifier="CompositionEditor/UnvaluedRowsBanner">
				{t("EDIT_COMPOSITION.POSITION_SIZING.VALUATION_FAILED_NOTICE.BODY", {
					count,
					date: formatDate(instrumentBuilder.getMarketDate().value),
				})}{" "}
				<ActionText
					data-qualifier="CompositionEditor/UnvaluedRowsBanner/Retry"
					onClick={() => instrumentBuilder.retryValuations()}
				>
					{t("EDIT_COMPOSITION.POSITION_SIZING.VALUATION_FAILED_NOTICE.RETRY")}
				</ActionText>
			</span>
		),
	};
}
